import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class DocGenService extends RLBaseService {
    static $inject = ["$resource", "$q"];
    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    createDoc(request: Models.IDocGenRequest) {
        return this.toRLService<Models.IDocGenResponse>("/api/docgen/rundocgen").post(request).$promise;
    }

    convertFormat(uri: string, fileName: string, fromExt: string, toExt: string) {
        var data = {
            uri: uri,
            fileName: fileName,
            fromExt: fromExt,
            toExt: toExt
        };
        return this.toRLService<Models.ISignedUrl>("/api/docgen/convertFormat").post(data).$promise;
    }
}